import styled from "styled-components";

const YourSituationColumns = styled.div`
  column-gap: 60px;
  column-width: 300px;
  column-count: 2;
`;

export default YourSituationColumns;
